import { styled } from '@mui/material';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '../Button';
import { ArrowRightIcon } from '../Icons';
import { CalculatorSubmitButtonProps } from './types';

const StyledButton = styled(Button)(({ theme }) => ({
  '&.MuiButton-root': {
    backgroundColor: theme.colors.white,
    border: `1px solid ${theme.colors.main}`,
    color: theme.colors.main,
    fontSize: '1rem',
    margin: 0,
    display: 'flex',
    borderRadius: '5rem',
    padding: '0.8rem 3rem',
    fontWeight: 900,
    textTransform: 'none',

    svg: {
      marginRight: '0.8rem',
    },
  },
}));

export const CalculatorBackButton: FC<CalculatorSubmitButtonProps> = ({
  onClick,
  textKey = 'common.prevPage',
  isSvg = true,
}) => (
  <StyledButton onClick={onClick}>
    {isSvg && <ArrowRightIcon className={'rotate-180'} />}
    <FormattedMessage id={textKey} />
  </StyledButton>
);
